// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangeOpponentContactDetails_details_line__jQtyJ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ChangeOpponentContactDetails_detail__RR4R5 {
  width: 43%;
}

.ChangeOpponentContactDetails_arrow__WCJx- {
  width: 3%;
}
.ChangeOpponentContactDetails_gender_select__CFTs8 {
  width: 28%;
  margin-right: 15%;
}

.ChangeOpponentContactDetails_not_set__xTROT {
  color: rgb(171, 164, 164);
  font-style: italic;
}

.ChangeOpponentContactDetails_text_input__Z1Ofa {
  margin: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/ChangeOpponentContactDetailsPopup.js/ChangeOpponentContactDetails.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".details_line {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.detail {\n  width: 43%;\n}\n\n.arrow {\n  width: 3%;\n}\n.gender_select {\n  width: 28%;\n  margin-right: 15%;\n}\n\n.not_set {\n  color: rgb(171, 164, 164);\n  font-style: italic;\n}\n\n.text_input {\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details_line": `ChangeOpponentContactDetails_details_line__jQtyJ`,
	"detail": `ChangeOpponentContactDetails_detail__RR4R5`,
	"arrow": `ChangeOpponentContactDetails_arrow__WCJx-`,
	"gender_select": `ChangeOpponentContactDetails_gender_select__CFTs8`,
	"not_set": `ChangeOpponentContactDetails_not_set__xTROT`,
	"text_input": `ChangeOpponentContactDetails_text_input__Z1Ofa`
};
export default ___CSS_LOADER_EXPORT___;
